module.exports = __webpack_public_path__ + "static/icon-creativeprocess-67881a4dc4fa55618f9556f4be1e5b55.svg";